const bmwBlue = '#1c69d3';
const bmwDarkBlue = '#175ec1';
const miniMaroon = '#98202a';
const miniDarkMaroon = '#811c25';
const green = '#73ba69';
const blue = '#1c69d3';
// const backgroundGrey = '#f8f8fb';
const black = '#000000';
const inactiveGrey = '#dcdce1';

export const bmwTheme = {
  palette: {
    primary: bmwBlue,
    secondary: bmwDarkBlue,
  },
  button: {
    removeFromCart: green,
    activeBorder: 'solid 1px rgba(28, 105, 211, 0.43)',
    activeText: blue,
    enabled: bmwBlue,
    inactiveText: inactiveGrey,
    inactiveBorder: `solid 1px ${inactiveGrey}`,
  },
  charts: {
    comparison: {
      selected: '#336ACC',
    },
    pipeline: ['#fecb00', '#aea400', '#92a2bd', '#91785b', '#000000'],
    advanced: {
      stock: '#0064d9',
      presold: '#e6e6f0',
    },
  },
  dropDownText: '#1366d6',
  sideNav: {
    selectedNavLarge: '66px',
    selectedNavSmall: '50px',
  },
  font: 'HelveticaNeue',
};

export const miniTheme = {
  palette: {
    primary: miniMaroon,
    secondary: miniDarkMaroon,
  },
  button: {
    removeFromCart: miniMaroon,
    activeBorder: 'solid 1px rgba(0, 0, 0, 0.2)',
    activeText: black,
    enabled: miniMaroon,
    inactiveText: inactiveGrey,
    inactiveBorder: `solid 1px ${inactiveGrey}`,
  },
  charts: {
    comparison: {
      selected: miniMaroon,
    },
    pipeline: ['#006978', '#0087aa', '#96b428', '#cdb400', '#6e3246'],
    advanced: {
      stock: miniMaroon,
      presold: inactiveGrey,
    },
  },
  dropDownText: miniMaroon,
  sideNav: {
    selectedNavLarge: '22px',
    selectedNavSmall: '22px',
  },
  font: 'MiniSerif',
  orderDashboard: {
    fontSize: '24px',
    fontWeight: 'bold',
    letterSpacing: '1.8px',
    color: black,
  },
};
